import React, { useState, useEffect, useContext, useRef } from "react";
import clsx from "clsx";
import { useTheme } from "@material-ui/core/styles";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  Chip,
  ClickAwayListener,
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import {
  Group,
  MoveToInbox as MoveToInboxIcon,
  CheckBox as CheckBoxIcon,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  Add as AddIcon,
  TextRotateUp,
  TextRotationDown,
  Person as PersonIcon,
  Forum as ForumIcon,
  ConfirmationNumber as ConfirmationNumberIcon,
} from "@material-ui/icons";
import ToggleButton from "@material-ui/lab/ToggleButton";

import { FilterAltOff, FilterAlt, PlaylistAddCheckOutlined } from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import { Button } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import {
  getStoredCompanyTimezone,
  formatCompanyDateTime,
  resolveCompanyTimezone
} from "../../utils/companyTimezone";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    width: "calc(100% - 4px)",
    maxWidth: "calc(100% - 4px)",
    marginLeft: 2,
    marginRight: 2,
    alignSelf: "flex-start",
    flexDirection: "column",
    overflow: "hidden",
    boxSizing: "border-box",
    padding: 2,
    border: "none",
    backgroundColor: "transparent",
  },
  tabPanelContainer: {
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    padding: "0 0 2px 0",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  ticketsInnerWrapper: {
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
    borderRadius: 10,
    boxShadow: "none",
    backgroundColor: "transparent",
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
      padding: theme.spacing(0.25, 0.5),
      marginRight: theme.spacing(0.25),
      marginLeft: theme.spacing(0.25),
    },

    // Específico para monitores de 11-13 polegadas
    '@media (max-width: 1366px)': {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },

  tabPanelItem: {
    flex: "1 1 0",
    minWidth: 0,
    fontSize: 10,
    marginLeft: 0,
    position: "relative",
    overflow: "hidden",
    transition: "all 0.3s ease",
    fontWeight: 500,
    borderRadius: "12px",
    margin: 4,
    height: 56,
    minHeight: 56,
    padding: theme.spacing(0.5, 0.25),
    textTransform: "none",
    opacity: 0.7,
    "&.Mui-selected": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "#ffffff" : "#232628",
      boxShadow: theme.mode === "light"
        ? "3px 3px 6px rgba(0,0,0,0.06), -3px -3px 6px rgba(255,255,255,0.9)"
        : "3px 3px 6px rgba(0,0,0,0.4), -3px -3px 6px rgba(255,255,255,0.03)",
    },
    "&:hover": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "rgba(255, 255, 255, 0.5)" : "rgba(255, 255, 255, 0.05)",
    },
    "& .MuiTab-wrapper": {
      width: "100%",
      height: "100%",
      overflow: "hidden",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 9,
      height: 52,
      minHeight: 52,
      padding: theme.spacing(0.5, 0.1),
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 8,
      padding: theme.spacing(0.4, 0.05),
    },
  },

  tabIndicator: {
    display: "none",
  },
  tabsBadge: {
    top: "105%",
    right: "55%",
    transform: "translate(45%, 0)",
    whiteSpace: "nowrap",
    zIndex: 10,
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },
  firstTabsBadge: {
    left: 0,
    right: "auto",
    transform: "translate(0, 0)",
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    overflow: "visible",
    background: "transparent",
    borderRadius: 8,
    border: "none",
    boxShadow: "none",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    marginLeft: 0,
    marginRight: 0,
    padding: theme.spacing(0.5),
  },
  ticketActionsGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    columnGap: theme.spacing(1.25),
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflow: "visible",
    "& > .MuiBadge-root": {
      flex: "0 0 34px",
      width: 34,
      height: 34,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
    [theme.breakpoints.down("sm")]: {
      columnGap: theme.spacing(0.75),
      "& > .MuiBadge-root": {
        flexBasis: 30,
        width: 30,
        height: 30,
      },
    },
    "@media (max-width: 1366px)": {
      columnGap: theme.spacing(0.75),
      "& > .MuiBadge-root": {
        flexBasis: 30,
        width: 30,
        height: 30,
      },
    },
  },
  queueSelectAction: {
    flex: "0 1 auto !important",
    width: "auto !important",
    height: "auto !important",
    minWidth: 120,
    marginLeft: 0,
    "& > *": {
      maxWidth: "100%",
    },
  },

  serachInputWrapper: {
    position: "relative",
    flex: "0 0 auto",
    height: 40,
    width: "auto",
    boxSizing: "border-box",
    display: "flex",
    borderRadius: 40,
    padding: 4,
    border: "none",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: 0,
    marginRight: 0,
  },

  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
  },
  searchDropdown: {
    position: "absolute",
    top: "calc(100% + 8px)",
    left: 0,
    right: 0,
    zIndex: 20,
    borderRadius: 18,
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[8],
    maxHeight: "70vh",
    overflowY: "auto",
  },
  searchDropdownHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
  },
  searchDropdownSection: {
    "& + &": {
      marginTop: theme.spacing(1.5),
    },
  },
  searchSectionTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    marginBottom: theme.spacing(0.5),
  },
  searchSectionList: {
    padding: 0,
  },
  searchResultItem: {
    borderRadius: 14,
    marginBottom: theme.spacing(0.5),
    border: `1px solid transparent`,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.divider,
    },
  },
  searchResultItemActive: {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.primary.main,
  },
  searchResultPrimary: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  searchResultSecondary: {
    color: theme.palette.text.secondary,
  },
  searchResultMeta: {
    display: "block",
    marginTop: theme.spacing(0.25),
    fontSize: "0.78rem",
    color: theme.palette.text.secondary,
    opacity: 0.9,
  },
  searchResultSnippet: {
    display: "block",
    marginTop: theme.spacing(0.25),
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },
  searchEmptyState: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  searchLoadingState: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  searchAvatar: {
    color: "#fff",
    backgroundColor: theme.palette.primary.main,
  },
  searchHint: {
    padding: theme.spacing(1, 1.5),
    fontSize: 12,
    color: theme.palette.text.secondary,
  },

  badge: {
    // right: "-10px",
  },

  counterBadge: {
    minWidth: 18,
    height: 18,
    borderRadius: 9,
    padding: "0 4px",
    fontSize: 11,
    lineHeight: "18px",
    fontWeight: 700,
    color: "#fff",
    backgroundColor: theme.palette.primary.main,
    textAlign: "center",
    boxSizing: "border-box",
  },
  
  modernTabs: {
    minHeight: 64,
    height: 64,
    width: "100%",
    maxWidth: "100%",
    overflowX: "hidden",
    overflowY: "hidden",
    borderRadius: 16,
    backgroundColor: theme.mode === "light" ? "#f0f2f5" : "#191c1e",
    boxShadow: theme.mode === "light"
      ? "inset 3px 3px 6px #d1d9e6, inset -3px -3px 6px #ffffff"
      : "inset 3px 3px 6px #0d0e10, inset -3px -3px 6px #25292c",
    padding: "0",
    margin: "12px 0 8px 0",
    transition: "all 0.3s ease",
    position: "relative",
    "& .MuiTabs-flexContainer": {
      width: "100%",
      flexWrap: "nowrap",
      gap: 0,
    },
    "& .MuiTabs-scroller": {
      overflowX: "hidden !important",
      overflowY: "hidden !important",
    },
  },

  tabLabelContainer: {
    width: "100%",
    minWidth: 0,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    flexWrap: "nowrap",
    overflow: "hidden",
  },

  tabIconRow: {
    width: "100%",
    height: 22,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    overflow: "hidden",
  },

  tabLabelText: {
    marginLeft: 4,
    fontSize: 11,
    lineHeight: "14px",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    transition: "all 0.2s ease",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 4,
      fontSize: 9,
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: 2,
      fontSize: 8,
    },
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  confirmDialogPaper: {
    borderRadius: 18,
    overflow: "hidden",
    minWidth: 520,
    [theme.breakpoints.down("sm")]: {
      minWidth: "calc(100% - 32px)",
      margin: 16,
    },
  },
  confirmDialogTitle: {
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark || "#6a3fb5"} 100%)`,
    color: "#fff",
    fontSize: "1.5rem",
    fontWeight: 700,
    padding: theme.spacing(2.5, 3),
  },
  confirmDialogContent: {
    padding: theme.spacing(3),
    fontSize: "1.05rem",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
  },
  confirmDialogActions: {
    padding: theme.spacing(2, 3, 2.5),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    justifyContent: "flex-end",
    gap: theme.spacing(1.5),
  },
  confirmDialogCancel: {
    minWidth: 140,
    borderRadius: 10,
    color: theme.palette.text.secondary,
    fontWeight: 600,
    textTransform: "none",
  },
  confirmDialogConfirm: {
    minWidth: 180,
    borderRadius: 10,
    color: "#fff",
    fontWeight: 700,
    textTransform: "none",
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark || "#6a3fb5"} 100%)`,
    "&:hover": {
      background: `linear-gradient(135deg, ${theme.palette.primary.dark || theme.palette.primary.main} 0%, ${theme.palette.primary.main} 100%)`,
    },
  },
  filterIcon: {
    marginRight: 6,
    alignSelf: "center",
    color: theme.mode === "light" ? "#0872b9" : "#FFF",
    cursor: "pointer",
  },
  button: {
    height: 30,
    width: 30,
    border: "2px solid",
    borderColor: "#aaa",
    borderRadius: 8,
    marginRight: 8,
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  icon: {
    color: "#aaa",
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  buttonOpen: {
    "& $icon": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  // Classe padronizada para todos os botões de ação
  standardButton: {
    height: 34,
    width: 34,
    border: "none",
    borderWidth: "0 !important",
    borderRadius: "50%",
    marginRight: 0,
    padding: 0,
    minWidth: 34,
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#232628",
    boxShadow: theme.mode === "light" 
      ? "3px 3px 8px rgba(0,0,0,0.08), -3px -3px 8px rgba(255,255,255,0.9)" 
      : "3px 3px 8px rgba(0,0,0,0.4), -3px -3px 8px rgba(255,255,255,0.03)",
    transition: "all 0.3s ease",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: theme.mode === "light" 
        ? "4px 4px 10px rgba(0,0,0,0.12), -4px -4px 10px rgba(255,255,255,0.95)" 
        : "4px 4px 10px rgba(0,0,0,0.5), -4px -4px 10px rgba(255,255,255,0.05)",
    },
    [theme.breakpoints.down('sm')]: {
      height: 30,
      width: 30,
      minWidth: 30,
    },
    '@media (max-width: 1366px)': {
      height: 30,
      width: 30,
      minWidth: 30,
    },
  },
  activeButton: {
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark || "#6a3fb5"} 100%) !important`,
    boxShadow: theme.mode === "light"
      ? "inset 2px 2px 5px rgba(0,0,0,0.2)"
      : "inset 2px 2px 5px rgba(0,0,0,0.5)",
    "& $standardIcon": {
      color: "#ffffff !important",
    },
  },
  standardIcon: {
    color: theme.mode === "light" ? "#4b5563" : "#9ca3af",
    fontSize: 18,
    transition: "all 0.3s ease",
    "&:hover": {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  activeIcon: {
    color: "#ffffff !important",
  },
}));

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const searchTimeoutRef = useRef(null);
  const [searchParam, setSearchParam] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");
  const [tab, setTab] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [sortTickets, setSortTickets] = useState(false);

  const searchInputRef = useRef();
  const [searchOnMessages] = useState(true);
  const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
  const [globalSearchError, setGlobalSearchError] = useState("");
  const [globalSearchOpen, setGlobalSearchOpen] = useState(false);
  const [globalSearchResults, setGlobalSearchResults] = useState({
    contacts: [],
    tickets: [],
    messages: [],
  });
  const [highlightedResultKey, setHighlightedResultKey] = useState(null);

  const { ticketId } = useParams();
  const { user, socket } = useContext(AuthContext);
  const companyTimezone = resolveCompanyTimezone(user?.company?.timezone || getStoredCompanyTimezone());
  const { profile } = user;
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { currentTicket, setCurrentTicket, tabOpen, setTabOpen } = useContext(TicketsContext);
  const currentTicketRef = useRef(currentTicket);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);
  const [allCount, setAllCount] = useState(0);

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isHoveredAll, setIsHoveredAll] = useState(false);
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);
  const [isHoveredSort, setIsHoveredSort] = useState(false);

  const [isFilterActive, setIsFilterActive] = useState(false);
  const canShowAllTab = ["enabled", "habilitado"].includes(String(user?.allUserChat || "").toLowerCase());
  const visibleTabsCount = (user.allowGroup ? 1 : 0) + (canShowAllTab ? 3 : 2);
  const tabWidthPercent = `${100 / visibleTabsCount}%`;
  const tabDynamicStyle = {
    flexBasis: tabWidthPercent,
    maxWidth: tabWidthPercent,
  };

  useEffect(() => {
    currentTicketRef.current = currentTicket;
  }, [currentTicket]);

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  useEffect(() => {
    if (!socket || typeof socket.on !== "function" || !user?.companyId) {
      return;
    }

    const onCompanyTicketScreenControl = (data) => {
      if (data.action !== "update" || !data.ticket) {
        return;
      }

      const updatedTicket = data.ticket;
      const selectedTicket = currentTicketRef.current || {};
      const selectedTicketId = selectedTicket?.id || null;
      const selectedTicketUuid = selectedTicket?.uuid || ticketId || null;
      const isCurrentTicket =
        updatedTicket.id === selectedTicketId ||
        (selectedTicketUuid && updatedTicket.uuid === selectedTicketUuid);
      const oldStatus = selectedTicket?.status || (isCurrentTicket ? tabOpen : null);
      const newStatus = updatedTicket?.status;

      console.info("[TICKET_SOCKET_UPDATE_RECEIVED]", {
        ticketId: updatedTicket?.id,
        oldStatus,
        newStatus,
        selectedTicketId,
        currentTab: tabOpen
      });

      if (!isCurrentTicket) {
        return;
      }

      setCurrentTicket((prevState) => ({
        ...prevState,
        ...updatedTicket,
        code: prevState?.code || updatedTicket?.uuid || String(updatedTicket?.id || "")
      }));

      const movedFromPendingToOpen =
        oldStatus === "pending" &&
        ["open", "group"].includes(newStatus);
      const wasAssumedByCurrentUser = updatedTicket?.userId === user?.id;

      if (!movedFromPendingToOpen || !wasAssumedByCurrentUser) {
        return;
      }

      const destinationTab = newStatus === "group" ? "group" : "open";
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("tab", destinationTab);
      const route = `/tickets/${updatedTicket.uuid}?${searchParams.toString()}`;

      console.info("[TICKET_PENDING_TO_OPEN_KEEP_CONTEXT]", {
        ticketId: updatedTicket?.id,
        uuid: updatedTicket?.uuid,
        from: "pending",
        to: newStatus,
        userId: updatedTicket?.userId
      });

      console.info("[TICKET_NAVIGATE_AFTER_ASSUME]", {
        route,
        tab: destinationTab,
        ticketId: updatedTicket?.id
      });

      setTab("open");
      setTabOpen(destinationTab);
      history.replace({
        pathname: `/tickets/${updatedTicket.uuid}`,
        search: `?${searchParams.toString()}`
      });
    };

    socket.on(`company-${user.companyId}-ticket`, onCompanyTicketScreenControl);

    return () => {
      socket.off(`company-${user.companyId}-ticket`, onCompanyTicketScreenControl);
    };
  }, [history, location.search, setCurrentTicket, setTabOpen, socket, tabOpen, ticketId, user?.companyId, user?.id]);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN" || user.allUserChat.toUpperCase() === "ENABLED") {
      setShowAllTickets(false);
    }
    
    // Verificar se há parâmetro 'tab' na URL ao carregar
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam && ["pending", "open", "group", "all", "closed"].includes(tabParam)) {
      if (tabParam === "all" && !canShowAllTab) {
        setTab("open");
        setTabOpen("open");
        return;
      }
      // Definir a tab principal primeiro
      if (tabParam === "pending") {
        setTab("open"); // "Aguardando" está dentro da tab "open"
      } else if (tabParam === "open") {
        setTab("open");
      } else if (tabParam === "closed") {
        setTab("closed");
      } else if (tabParam === "group") {
        setTab("open"); // "Grupos" está dentro da tab "open"
      } else if (tabParam === "all") {
        setTab("open"); // "Todos" está dentro da tab "open"
      }
      // Depois definir a sub-aba (tabOpen)
      setTimeout(() => {
        setTabOpen(tabParam);
      }, 50);
    }
  }, []);

  // Monitorar mudanças na URL para atualizar a aba quando necessário
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam && ["pending", "open", "group", "all", "closed"].includes(tabParam)) {
      if (tabParam === "all" && !canShowAllTab) {
        setTab("open");
        if (tabOpen !== "open") {
          setTabOpen("open");
        }
        return;
      }
      // Se o parâmetro tab mudou, atualizar a aba
      if (tabOpen !== tabParam) {
        // Definir a tab principal primeiro
        if (tabParam === "pending") {
          setTab("open"); // "Aguardando" está dentro da tab "open"
        } else if (tabParam === "open") {
          setTab("open");
        } else if (tabParam === "closed") {
          setTab("closed");
        } else if (tabParam === "group") {
          setTab("open"); // "Grupos" está dentro da tab "open"
        } else if (tabParam === "all") {
          setTab("open"); // "Todos" está dentro da tab "open"
        }
        // Depois definir a sub-aba (tabOpen) com um pequeno delay
        setTimeout(() => {
          setTabOpen(tabParam);
        }, 100);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, tabOpen, setTabOpen, canShowAllTab]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch(!forceSearch);
  }, [tab]);

  const handleSearch = (e) => {
    const searchedTerm = e.target.value;
    const normalizedTerm = searchedTerm.trim();

    setSearchInputValue(searchedTerm);
    clearTimeout(searchTimeoutRef.current);

    if (normalizedTerm === "") {
      setSearchParam("");
      setGlobalSearchOpen(false);
      setGlobalSearchError("");
      setGlobalSearchResults({
        contacts: [],
        tickets: [],
        messages: [],
      });
      return;
    }

    searchTimeoutRef.current = setTimeout(() => {
      setSearchParam(normalizedTerm);
      setGlobalSearchOpen(true);
    }, 350);
  };

  const handleBack = () => {
    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    handleBack();
    if (newValue === "all" && !canShowAllTab) {
      setTabOpen("open");
      setShowAllTickets(false);
      return;
    }
    setTabOpen(newValue);
    setShowAllTickets(newValue === "all");
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { display: "none" };
    }
    return { display: "flex", width: "100%", height: "100%" };
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      const { data } = await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);

    clearTimeout(searchTimeoutRef.current);

    if (tags.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeoutRef.current = setTimeout(() => {
      setSelectedTags(tags);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);

    clearTimeout(searchTimeoutRef.current);

    if (users.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeoutRef.current = setTimeout(() => {
      setSelectedUsers(users);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);

    clearTimeout(searchTimeoutRef.current);

    if (whatsapp.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeoutRef.current = setTimeout(() => {
      setSelectedWhatsapp(whatsapp);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    clearTimeout(searchTimeoutRef.current);

    if (statusFilter.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeoutRef.current = setTimeout(() => {
      setSelectedStatus(statusFilter);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setTab("open");
      setSearchParam("");
      setSearchInputValue("");
      setGlobalSearchOpen(false);
      setSelectedTags([]);
      setSelectedUsers([]);
      setSelectedWhatsapp([]);
      setSelectedStatus([]);
      setForceSearch(!forceSearch);
      if (searchInputRef.current) {
        searchInputRef.current.value = "";
      }
    } else {
      setFilter(true);
      setTab("search");
    }
  };

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClosed = () => {
    setOpen(false);
  };

  const tooltipTitleStyle = {
    fontSize: "10px",
  };

  useEffect(() => {
    let mounted = true;

    const fetchGlobalSearch = async () => {
      if (searchParam.length < 2) {
        if (!mounted) return;
        setGlobalSearchLoading(false);
        setGlobalSearchError("");
        setGlobalSearchResults({
          contacts: [],
          tickets: [],
          messages: [],
        });
        setHighlightedResultKey(null);
        return;
      }

      setGlobalSearchLoading(true);
      setGlobalSearchError("");

      try {
        const { data } = await api.get("/global-search", {
          params: {
            q: searchParam,
            type: "all",
            limit: 5,
          },
        });

        if (!mounted) return;

        setGlobalSearchResults({
          contacts: data.contacts || [],
          tickets: data.tickets || [],
          messages: data.messages || [],
        });
        setGlobalSearchOpen(true);
      } catch (error) {
        if (!mounted) return;
        setGlobalSearchResults({
          contacts: [],
          tickets: [],
          messages: [],
        });
        setGlobalSearchError("Erro ao pesquisar. Tente novamente.");
      } finally {
        if (mounted) {
          setGlobalSearchLoading(false);
        }
      }
    };

    fetchGlobalSearch();

    return () => {
      mounted = false;
    };
  }, [searchParam]);

  useEffect(() => () => clearTimeout(searchTimeoutRef.current), []);

  const globalSearchSections = [
    {
      key: "contacts",
      label: "Contatos",
      icon: <PersonIcon fontSize="small" />,
      items: globalSearchResults.contacts || [],
    },
    {
      key: "tickets",
      label: "Tickets",
      icon: <ConfirmationNumberIcon fontSize="small" />,
      items: globalSearchResults.tickets || [],
    },
    {
      key: "messages",
      label: "Mensagens",
      icon: <ForumIcon fontSize="small" />,
      items: globalSearchResults.messages || [],
    },
  ];

  const flattenedSearchResults = globalSearchSections.flatMap((section) =>
    section.items.map((item, index) => ({
      ...item,
      sectionKey: section.key,
      resultKey: `${section.key}-${item.id}-${index}`,
    }))
  );

  const totalGlobalResults = flattenedSearchResults.length;

  const formatSearchResultDateTime = (value) => {
    if (!value) return null;
    return formatCompanyDateTime(value, companyTimezone);
  };

  useEffect(() => {
    if (!flattenedSearchResults.length) {
      setHighlightedResultKey(null);
      return;
    }

    setHighlightedResultKey((current) => {
      if (current && flattenedSearchResults.some((item) => item.resultKey === current)) {
        return current;
      }

      return flattenedSearchResults[0].resultKey;
    });
  }, [totalGlobalResults]);

  const openSearchResult = (item) => {
    if (!item) return;

    setGlobalSearchOpen(false);

    if (item.type === "message") {
      if (item.ticketUuid) {
        history.push(`/tickets/${item.ticketUuid}?focusedMessageId=${item.id}`);
      }
      return;
    }

    if (item.type === "ticket") {
      if (item.ticketUuid) {
        history.push(`/tickets/${item.ticketUuid}`);
      }
      return;
    }

    if (item.ticketUuid) {
      history.push(`/tickets/${item.ticketUuid}`);
      return;
    }

    const contactSearch = item.subtitle || item.title || "";
    history.push(`/contacts?searchParam=${encodeURIComponent(contactSearch)}`);
  };

  const handleSearchKeyDown = (event) => {
    if (!globalSearchOpen || !flattenedSearchResults.length) {
      if (event.key === "Escape") {
        setGlobalSearchOpen(false);
      }
      return;
    }

    const currentIndex = flattenedSearchResults.findIndex(
      (item) => item.resultKey === highlightedResultKey
    );

    if (event.key === "ArrowDown") {
      event.preventDefault();
      const nextIndex = currentIndex >= flattenedSearchResults.length - 1 ? 0 : currentIndex + 1;
      setHighlightedResultKey(flattenedSearchResults[nextIndex].resultKey);
      return;
    }

    if (event.key === "ArrowUp") {
      event.preventDefault();
      const prevIndex = currentIndex <= 0 ? flattenedSearchResults.length - 1 : currentIndex - 1;
      setHighlightedResultKey(flattenedSearchResults[prevIndex].resultKey);
      return;
    }

    if (event.key === "Enter") {
      event.preventDefault();
      const selectedItem =
        flattenedSearchResults.find((item) => item.resultKey === highlightedResultKey) ||
        flattenedSearchResults[0];
      openSearchResult(selectedItem);
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      setGlobalSearchOpen(false);
    }
  };

  const renderSearchDropdown = () => {
    if (!globalSearchOpen) return null;

    return (
      <Paper elevation={8} className={classes.searchDropdown}>
        <div className={classes.searchDropdownHeader}>
          <Typography variant="subtitle2">
            {i18n.t("tickets.globalSearch.title")}
          </Typography>
          {searchParam.length >= 2 && (
            <Chip
              size="small"
              color="primary"
              label={i18n.t("tickets.globalSearch.results", { count: totalGlobalResults })}
            />
          )}
        </div>

        {searchParam.length < 2 && (
          <div className={classes.searchHint}>
            {i18n.t("tickets.globalSearch.minChars")}
          </div>
        )}

        {searchParam.length >= 2 && globalSearchLoading && (
          <div className={classes.searchLoadingState}>
            <Typography variant="body2">{i18n.t("common.loading.searching")}</Typography>
          </div>
        )}

        {searchParam.length >= 2 && !globalSearchLoading && globalSearchError && (
          <div className={classes.searchEmptyState}>
            <Typography variant="body2">{globalSearchError}</Typography>
          </div>
        )}

        {searchParam.length >= 2 &&
          !globalSearchLoading &&
          !globalSearchError &&
          totalGlobalResults === 0 && (
            <div className={classes.searchEmptyState}>
              <Typography variant="body2">
                {i18n.t("tickets.globalSearch.noResults")}
              </Typography>
            </div>
          )}

        {searchParam.length >= 2 &&
          !globalSearchLoading &&
          !globalSearchError &&
          totalGlobalResults > 0 &&
          globalSearchSections.map((section) => {
            if (!section.items.length) return null;

            return (
              <div key={section.key} className={classes.searchDropdownSection}>
                <div className={classes.searchSectionTitle}>
                  <Box display="flex" alignItems="center" gridGap={8}>
                    {section.icon}
                    <Typography variant="subtitle2">{section.label}</Typography>
                  </Box>
                  <Chip size="small" label={section.items.length} />
                </div>

                <List className={classes.searchSectionList}>
                  {section.items.map((item, index) => {
                    const resultKey = `${section.key}-${item.id}-${index}`;
                    const isActive = highlightedResultKey === resultKey;
                    const subtitle = item.subtitle || i18n.t("common.noData");
                    const snippet = item.snippet || "";
                    const messageDateTime =
                      section.key === "messages"
                        ? formatSearchResultDateTime(item.createdAt || item.updatedAt)
                        : null;

                    return (
                      <ListItem
                        button
                        key={resultKey}
                        onMouseEnter={() => setHighlightedResultKey(resultKey)}
                        onClick={() => openSearchResult(item)}
                        className={`${classes.searchResultItem} ${isActive ? classes.searchResultItemActive : ""}`}
                      >
                        <ListItemAvatar>
                          <Avatar className={classes.searchAvatar}>
                            {section.key === "contacts" && <PersonIcon />}
                            {section.key === "tickets" && <ConfirmationNumberIcon />}
                            {section.key === "messages" && <ForumIcon />}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={<span className={classes.searchResultPrimary}>{item.title || i18n.t("common.noData")}</span>}
                          secondary={(
                            <span className={classes.searchResultSecondary}>
                              {subtitle}
                              {messageDateTime ? (
                                <span className={classes.searchResultMeta}>
                                  {messageDateTime}
                                </span>
                              ) : null}
                              {snippet ? (
                                <span className={classes.searchResultSnippet}>{snippet}</span>
                              ) : null}
                            </span>
                          )}
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </div>
            );
          })}
      </Paper>
    );
  };

  return (
    <Paper elevation={0} className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <ClickAwayListener onClickAway={() => setGlobalSearchOpen(false)}>
        <div className={clsx(classes.serachInputWrapper, "neumorphic-inset")}>
          <Tooltip placement="top" title={i18n.t("tickets.search.placeholder")}>
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <SearchIcon className={classes.searchIcon} />
            </div>
          </Tooltip>
          <InputBase
            value={searchInputValue}
            className={classes.searchInput}
            inputRef={searchInputRef}
            placeholder={i18n.t("tickets.globalSearch.placeholder")}
            type="search"
            onChange={handleSearch}
            onFocus={() => {
              if (searchInputValue.trim().length >= 2) {
                setGlobalSearchOpen(true);
              }
            }}
            onKeyDown={handleSearchKeyDown}
          />
          <IconButton
            style={{
              backgroundColor: "transparent",
              boxShadow: "none",
              border: "none",
              borderRadius: "50%",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
            variant="contained"
            aria-label={i18n.t("tickets.search.filterAria")}
            className={classes.filterIcon}
            onClick={() => {
              setIsFilterActive((prevState) => !prevState);
              handleFilter();
            }}
          >
            {isFilterActive ? (
              <FilterAlt className={classes.icon} />
            ) : (
              <FilterAltOff className={classes.icon} />
            )}
          </IconButton>
          {renderSearchDropdown()}
        </div>
      </ClickAwayListener>

      {filter === true && (
        <>
          <TagsFilter onFiltered={handleSelectedTags} />
          <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
          <StatusFilter onFiltered={handleSelectedStatus} />
          {profile === "admin" && (
            <>
              <UsersFilter onFiltered={handleSelectedUsers} />
            </>
          )}
        </>
      )}

      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Grid container alignItems="center">
          <Grid item className={classes.ticketActionsGroup}>
            <Dialog
              open={snackbarOpen}
              onClose={handleSnackbarClose}
              fullWidth
              maxWidth="sm"
              classes={{ paper: classes.confirmDialogPaper }}
            >
              <DialogTitle disableTypography className={classes.confirmDialogTitle}>
                {i18n.t("tickets.inbox.closedAll")}
              </DialogTitle>
              <DialogContent className={classes.confirmDialogContent}>
                <Typography variant="body1">
                  {i18n.t("tickets.inbox.closedAllTickets")}
                </Typography>
              </DialogContent>
              <DialogActions className={classes.confirmDialogActions}>
                <Button
                  onClick={handleSnackbarClose}
                  className={classes.confirmDialogCancel}
                >
                  {i18n.t("tickets.inbox.no")}
                </Button>
                <Button
                  onClick={CloseAllTicket}
                  className={classes.confirmDialogConfirm}
                  variant="contained"
                >
                  {i18n.t("tickets.inbox.yes")}
                </Button>
              </DialogActions>
            </Dialog>
<Badge
  color="primary"
  invisible={
    isHoveredAll ||
    !isHoveredNew ||
    isHoveredResolve ||
    isHoveredOpen ||
    isHoveredClosed
  }
  badgeContent={i18n.t("tickets.inbox.newTicket")}
  classes={{ badge: `${classes.tabsBadge} ${classes.firstTabsBadge}` }}
>
  <IconButton
    onMouseEnter={() => setIsHoveredNew(true)}
    onMouseLeave={() => setIsHoveredNew(false)}
    className={classes.standardButton}
    onClick={() => {
      setNewTicketModalOpen(true);
    }}
  >
    <AddIcon className={classes.standardIcon} />
  </IconButton>
</Badge>
{user.profile === "admin" && (
  <Badge
    color="primary"
    invisible={
      isHoveredAll ||
      isHoveredNew ||
      !isHoveredResolve ||
      isHoveredOpen ||
      isHoveredClosed
    }
    badgeContent={i18n.t("tickets.inbox.closedAll")}
    classes={{ badge: classes.tabsBadge }}
  >
    <IconButton
      onMouseEnter={() => setIsHoveredResolve(true)}
      onMouseLeave={() => setIsHoveredResolve(false)}
      className={classes.standardButton}
      onClick={handleSnackbarOpen}
    >
      <PlaylistAddCheckOutlined className={classes.standardIcon} />
    </IconButton>
  </Badge>
)}
{/* Botão "Abertos" */}
<Badge
  invisible={
    !(
      tab === "open" &&
      !isHoveredAll &&
      !isHoveredNew &&
      !isHoveredResolve &&
      !isHoveredClosed &&
      !isHoveredSort
    ) && !isHoveredOpen
  }
  badgeContent={i18n.t("tickets.inbox.open")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => {
      setIsHoveredOpen(true);
      setHoveredButton("open");
    }}
    onMouseLeave={() => {
      setIsHoveredOpen(false);
      setHoveredButton(null);
    }}
    className={`${classes.standardButton} ${
      (tab === "open" || isHoveredOpen) ? classes.activeButton : ''
    }`}
    onClick={() => handleChangeTab(null, "open")}
  >
    <MoveToInboxIcon
      className={`${classes.standardIcon} ${
        (tab === "open" || isHoveredOpen) ? classes.activeIcon : ''
      }`}
    />
  </IconButton>
</Badge>

{/* Botão "Resolvidos" */}
<Badge
  color="primary"
  invisible={
    !(
      tab === "closed" &&
      !isHoveredAll &&
      !isHoveredNew &&
      !isHoveredResolve &&
      !isHoveredOpen &&
      !isHoveredSort
    ) && !isHoveredClosed
  }
  badgeContent={i18n.t("tickets.inbox.resolverd")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => {
      setIsHoveredClosed(true);
      setHoveredButton("closed");
    }}
    onMouseLeave={() => {
      setIsHoveredClosed(false);
      setHoveredButton(null);
    }}
    className={`${classes.standardButton} ${
      (tab === "closed" || isHoveredClosed) ? classes.activeButton : ''
    }`}
    onClick={() => handleChangeTab(null, "closed")}
  >
    <CheckBoxIcon
      className={`${classes.standardIcon} ${
        (tab === "closed" || isHoveredClosed) ? classes.activeIcon : ''
      }`}
    />
  </IconButton>
</Badge>

{tab !== "closed" && tab !== "search" && (
  <Badge
    color="primary"
    invisible={
      !isHoveredSort ||
      isHoveredAll ||
      isHoveredNew ||
      isHoveredResolve ||
      isHoveredOpen ||
      isHoveredClosed
    }
    badgeContent={!sortTickets ? "Crescente" : "Decrescente"}
    classes={{ badge: classes.tabsBadge }}
  >
    <ToggleButton
      onMouseEnter={() => setIsHoveredSort(true)}
      onMouseLeave={() => setIsHoveredSort(false)}
      className={`${classes.standardButton} ${sortTickets ? classes.activeButton : ''}`}
      value="uncheck"
      selected={sortTickets}
      onChange={() => setSortTickets((prevState) => !prevState)}
    >
      {!sortTickets ? (
        <TextRotateUp className={`${classes.standardIcon} ${sortTickets ? classes.activeIcon : ''}`} />
      ) : (
        <TextRotationDown className={`${classes.standardIcon} ${classes.activeIcon}`} />
      )}
    </ToggleButton>
  </Badge>
)}

{/* Movido o seletor de filas para a mesma linha dos botões */}
<span className={`MuiBadge-root ${classes.queueSelectAction}`}>
  <TicketsQueueSelect
    selectedQueueIds={selectedQueueIds}
    userQueues={user?.queues}
    onChange={(values) => setSelectedQueueIds(values)}
  />
</span>
          </Grid>
        </Grid>
      </Paper>

      <TabPanel value={tab} name="open" className={classes.tabPanelContainer}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons={false}
          allowScrollButtonsMobile={false}
          TabIndicatorProps={{ className: classes.tabIndicator }}
          className={classes.modernTabs}
        >
          {/* ATENDENDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" className={classes.tabLabelContainer}>
                <Grid item className={classes.tabIconRow}>
                  <MessageSharpIcon
                    style={{
                      fontSize: 18,
                      color: tabOpen === "open" ? theme.palette.primary.main : "inherit",
                    }}
                  />
                  <span className={classes.counterBadge}>{openCount}</span>
                </Grid>
                <Grid item>
                  <Typography className={classes.tabLabelText} style={{ fontWeight: tabOpen === "open" ? 700 : 500, color: tabOpen === "open" ? theme.palette.primary.main : "inherit" }}>
                    {i18n.t("ticketsList.assignedHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem }}
            style={tabDynamicStyle}
          />

          {/* AGUARDANDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" className={classes.tabLabelContainer}>
                <Grid item className={classes.tabIconRow}>
                  <ClockIcon
                    style={{
                      fontSize: 18,
                      color: tabOpen === "pending" ? theme.palette.primary.main : "inherit",
                    }}
                  />
                  <span className={classes.counterBadge}>{pendingCount}</span>
                </Grid>
                <Grid item>
                  <Typography
                    className={classes.tabLabelText}
                    style={{ fontWeight: tabOpen === "pending" ? 700 : 500, color: tabOpen === "pending" ? theme.palette.primary.main : "inherit" }}
                  >
                    {i18n.t("ticketsList.pendingHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem }}
            style={tabDynamicStyle}
          />

          {/* TODOS */}
          {canShowAllTab && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center" className={classes.tabLabelContainer}>
                  <Grid item className={classes.tabIconRow}>
                    <MoveToInboxIcon
                      style={{
                        fontSize: 18,
                        color: tabOpen === "all" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                    <span className={classes.counterBadge}>{allCount}</span>
                  </Grid>
                  <Grid item>
                    <Typography
                      className={classes.tabLabelText}
                      style={{ fontWeight: tabOpen === "all" ? 700 : 500, color: tabOpen === "all" ? theme.palette.primary.main : "inherit" }}
                    >
                      {i18n.t("ticketsList.allHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"all"}
              name="all"
              classes={{ root: classes.tabPanelItem }}
              style={tabDynamicStyle}
            />
          )}

          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center" className={classes.tabLabelContainer}>
                  <Grid item className={classes.tabIconRow}>
                    <Group
                      style={{
                        fontSize: 18,
                        color: tabOpen === "group" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                    <span className={classes.counterBadge}>{groupingCount}</span>
                  </Grid>
                  <Grid item>
                    <Typography
                      className={classes.tabLabelText}
                      style={{ fontWeight: tabOpen === "group" ? 700 : 500, color: tabOpen === "group" ? theme.palette.primary.main : "inherit" }}
                    >
                      {i18n.t("ticketsList.groupingHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem }}
              style={tabDynamicStyle}
            />
          )}
        </Tabs>

        <Paper elevation={0} className={classes.ticketsInnerWrapper}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            showAll={user.profile === "admin" || user.allUserChat === 'enabled' ? showAllTickets : false}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
            />
          )}
          {canShowAllTab && (
            <TicketsList
              status="all"
              showAll={true}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setAllCount(val)}
              style={applyPanelStyle("all")}
              setTabOpen={setTabOpen}
            />
          )}
        </Paper>
      </TabPanel>

      <TabPanel value={tab} name="closed" className={classes.tabPanelContainer}>
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
        />
      </TabPanel>

      <TabPanel value={tab} name="search" className={classes.tabPanelContainer}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={selectedStatus}
              searchParam={searchParam}
              showAll={showAllTickets}
              tags={selectedTags}
              users={selectedUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={forceSearch}
              searchOnMessages={searchOnMessages}
              status="search"
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={false}
            tags={selectedTags}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
          />
        )}
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;
